import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Box, Typography, CircularProgress, Grid, List, ListItem, ListItemIcon, ListItemText, Divider } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SecurityIcon from '@material-ui/icons/Security';
import ArchiveIcon from '@material-ui/icons/Archive';
import MapsHomeIcon from '@material-ui/icons/Home';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import HelpOutlinedIcon from '@mui/icons-material/HelpOutlined';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ChatIcon from '@mui/icons-material/Chat';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ResponsiveAppBar from '../components/appbar';
import OrdCard from '../components/ordCard'; 
import QeeShop from '../components/qeeShop';
import OrdsEmpty from '../components/ordsEmpty';
import { fetchOrds } from '../api/service';
import QeeNavigator from '../context/navigator';
import { useAuth } from "../context/provider";
import { useNavigate } from "react-router-dom";
import { useConfluence } from "../components/qeeConfluenceProvider";

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    appBarWrapper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        width: '100%',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    listContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    uiProgress: {
        position: 'fixed',
        zIndex: '1000',
        height: '31px',
        width: '31px',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
    },
    drawerPaper: {
        width: 240,
    },
    listItem: {
        color: '#788',
        fontWeight: 600,
        fontSize: 16
    },
    mainContent: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        }
    }
});

const Ords = (props) => {
    const { gstate, setOpenQeeDialog, setIsFetching } = useAuth();
    const { setOpenConfluenceDialog } = useConfluence();
    const navigate = useNavigate();
    const { loadDashboard, loadAccount, loadChats, loadSacs } = QeeNavigator();

    const [state, setState] = useState(() => initStateFromSessionStorage('ords-global', {
        render: 'ordsActive',
        uiLoading: true,
        ords: [],
        filteredOrds: [],
        error: null,
        ordsType: 'insurance', // Set the initial type to "insurance"
        ordsStateFilter: { min: 100, max: 9999 }, // Active state filter
    }));
    const [listLoading, setListLoading] = useState(false);

    const useStyles = makeStyles({
        ...props,
        listItem: {
            color: '#788',
            fontWeight: 600,
            fontSize: 16,
        }
    });
    const classes = useStyles(props);

    useEffect(() => {
        // Automatically load "Aktive Versicherungen" on page load
        loadOrds('ordsActive', { min: 100, max: 9999 });
    }, []); // Empty dependency array ensures this runs once on component mount

    const loadOrds = (render, ordsStateFilter) => {
        setState((prevState) => ({
            ...prevState,
            render,
            ordsStateFilter,
        }));
        fetchOrdsData(ordsStateFilter);
    };

    const loadShop = () => {
        setState((prevState) => ({
            ...prevState,
            render: 'shop',
        }));
    };

    const fetchOrdsData = async (ordsStateFilter) => {
        setListLoading(true);
        const { min, max } = ordsStateFilter;
		var usrId;
		var usr = JSON.parse(sessionStorage.getItem('usr'));
		if (usr) {
			console.log('sessionStorage usr', usr);
			usrId = usr.usrId;
		} else {
			console.error('fetchOrdsData ERR:', 'No user data');
			setListLoading(true);
			return;
		}

        try {
            const data = await fetchOrds({
				usrId,
                type: state.ordsType,
                stateMin: min,
                stateMax: max,
            });

            if (data.err) {
                console.error('Failed to fetch ords:', data.err);
                setState((prevState) => ({
                    ...prevState,
                    error: data.err,
                    uiLoading: false,
                }));
            } else {
                setState((prevState) => ({
                    ...prevState,
                    ords: data.entries.results,
                    filteredOrds: data.entries.results,
                    uiLoading: false,
                }));
            }
        } catch (error) {
            console.error('fetchOrdsData ERR:', error);
            setState((prevState) => ({
                ...prevState,
                error: error.message,
                uiLoading: false,
            }));
        } finally {
            setListLoading(false);
        }
    };

    const handleClickOrd = (ord) => {
        navigate('/ord?id=' + ord.id);
    };

    const drawer = () => (
        <>
            <div className={classes.toolbar} />
            <List>
                <ListItem button key="Dashboard" onClick={loadDashboard}>
                    <ListItemIcon>
                        <MapsHomeIcon />
                    </ListItemIcon>
                    <ListItemText
                        disableTypography
                        primary={<Typography variant="body2" className={classes.listItem}>Dashboard</Typography>}
                    />
                </ListItem>
				<Divider />

                <ListItem button key="ordsActive" onClick={() => loadOrds('ordsActive', { min: 100, max: 9999 })}>
                    <ListItemIcon>
                        <SecurityIcon />
                    </ListItemIcon>
                    <ListItemText
                        disableTypography
                        primary={<Typography variant="body2" className={classes.listItem}>Aktive Versicherungen</Typography>}
                    />
                </ListItem>

                <ListItem button key="ordsArchived" onClick={() => loadOrds('ordsArchived', { min: 10000, max: '*' })}>
                    <ListItemIcon>
                        <ArchiveIcon />
                    </ListItemIcon>
                    <ListItemText
                        disableTypography
                        primary={<Typography variant="body2" className={classes.listItem}>Archivierte Versicherungen</Typography>}
                    />
                </ListItem>

                <Divider />

                <ListItem button key="shop" onClick={loadShop}>
                    <ListItemIcon>
                        <ShoppingCartIcon />
                    </ListItemIcon>
                    <ListItemText
                        disableTypography
                        primary={<Typography variant="body2" className={classes.listItem}>Shop</Typography>}
                    />
                </ListItem>
            </List>
        </>
    );

    const renderOrdList = (title) => (
        <Box className={classes.content}>
            <Typography variant="h4" className={classes.title}>{title}</Typography>
            <Box className={classes.mainContent}>
                <Box className={classes.listContainer}>
                    {listLoading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Grid container spacing={1}>
                            {state.filteredOrds.length > 0 ? (
                                state.filteredOrds.map((ord) => (
                                    <Grid item xs={12} key={ord.id}>
                                        <OrdCard 
                                            ord={ord} 
                                            onClick={() => handleClickOrd(ord)}
                                        />
                                    </Grid>
                                ))
                            ) : (
                                <Grid item xs={12}>
                                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
										<OrdsEmpty txt='Keine Versicherungen gefunden! <br/>Erstelle eine Versicherung aus dem <strong>Versicherungs-Shop</strong>.'/>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    )}
                </Box>
            </Box>
        </Box>
    );

    const switchSubpage = () => {
        switch (state.render) {
            case 'ordsActive':
                return renderOrdList('Aktive Versicherungen');
            case 'ordsArchived':
                return renderOrdList('Archivierte Versicherungen');
            case 'shop':
                return <QeeShop filter={'categories=300'} />;
            default:
                return <Box><Typography variant="h4">Aktive Versicherungen</Typography></Box>;
        }
    };

    const showConfluenceHome = () => {
        setOpenConfluenceDialog();
    };

    const showVersionInfo = () => {
        setOpenQeeDialog({ open: true, id: 'dlgVersionInfo' });
    };

    const logoutHandler = () => {
        localStorage.removeItem('AuthToken');
        navigate('/login');
    };

    const settings = [
        { nm: 'Mein Konto', fct: loadAccount, ico: <AccountBoxIcon /> },
		{ nm:'Nachrichten', fct:loadChats, ico:<ChatIcon />},				
		{ nm:'Aktivitäten', fct:loadSacs, ico:<ChecklistIcon />},			
        { nm: 'Wissensassistent', fct: showConfluenceHome, ico: <HelpOutlinedIcon /> },
        { nm: 'Versionsinfo', fct: showVersionInfo, ico: <PrivacyTipIcon /> },
        { nm: 'Logout', fct: logoutHandler, ico: <ExitToAppIcon /> }
    ];

    return (
        gstate.isFetching ? (
            <div className={classes.root}>
                {/* Loading indicator */}
            </div>
        ) : (
            <>
                <div className={classes.root}>
                    <Box className={classes.appBarWrapper}>
                        <ResponsiveAppBar
                            className={classes.appBar}
                            drawer={drawer}
                            switchSubpage={switchSubpage}
                            pages={[]}
                            settings={settings}
                        />
                    </Box>
                </div>
            </>
        )
    );
};

function initStateFromSessionStorage(globalKey, defaultState) {
    const savedState = sessionStorage.getItem(globalKey);
    return savedState ? JSON.parse(savedState) : defaultState;
}

function updateSessionStorage(globalKey, state) {
    sessionStorage.setItem(globalKey, JSON.stringify(state));
}

export default withStyles(styles)(Ords);
